import mdui from 'mdui';

function message(ms:string ){
    mdui.snackbar({
        message: JSON.stringify(ms),
        position: 'top'
    });
}

export default message;